import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router";
import { Layout } from "@/components/Layout";
import { Home } from "@/pages/Home";
import { About } from "@/pages/About";
import { Menu } from "@/pages/Menu";
import { Contact } from "@/pages/Contact";
import { Gallery } from "@/pages/Gallery";
import { PlanPickup } from "@/pages/PlanPickup";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="menu" element={<Menu />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="contact" element={<Contact />} />
          <Route path="plan-pickup" element={<PlanPickup />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
